import React from 'react';
import classnames from 'classnames';
import { Container, Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { getContext } from '@fiverr-private/fiverr_context';
import { DisplayName } from '../../../Overview/SellerProfile/DisplayName';
import Status from '../Status';
import { Badges } from '../../../Overview/Badges/Badges';

interface SellerDetailsProps {
  sellerUrl: any;
  onLinkClick: () => void;
}

export const SellerDetails: React.FC<SellerDetailsProps> = ({ sellerUrl, onLinkClick }) => {
  const {
    seller: { isAgency, displayName },
  } = useGigPageContext();

  const { pathParameters } = getContext();
  const { username } = pathParameters;
  const displayClassname = classnames({ 'text-display-4': isAgency, 'seller-card-name': !isAgency });

  return (
    <Stack gap={{ sm: '3', default: '2' }} justifyContent="center" alignItems="center" width="fit-content" wrap="wrap">
      <DisplayName
        classname={displayClassname}
        displayName={displayName}
        username={username}
        sellerUrl={sellerUrl}
        onClick={onLinkClick}
      />
      <Badges />
      <Container height="fit-content" paddingTop="0.5" width="fit-content" paddingLeft={{ default: '0', sm: '7' }}>
        <Status />
      </Container>
    </Stack>
  );
};
